import {ADMIN_DASHBOARD_INFO_SUCCESS} from '@julaya/common/store/actionTypes';

const actions = [ADMIN_DASHBOARD_INFO_SUCCESS];

const initialState = {
  adminDashboardInfo: null
};

export default [initialState, actions];
